import { REFRESH_TOKEN, JWT } from 'constants/system';

const clearSessionStorageJwtKey = () => {
  sessionStorage.removeItem(`SESSION_${JWT}_KEY`);
  sessionStorage.removeItem(`SESSION_${REFRESH_TOKEN}_KEY`);
};

export default clearSessionStorageJwtKey;
